import { useMemo } from 'react';

import KitIcon from '../../../assets/icons/KitIcon';
import ItemIcon from '../../../assets/icons/ItemIcon';

import Table from '../../shared/table/Table';

const DispatchChecklistsContainer = (props) => {
  const {
    kits,
    items,
    selectedKits,
    selectedItems,
    onKitSelected,
    onItemSelected,
    onSelectAllKits,
    onSelectAllItems
  } = props;

  const kitsColumns = useMemo(() => [
    { title: 'kit id', field: 'kitId', type: 'default', sort: true },
    { title: 'kit name', field: 'kitName', type: 'default', sort: true },
    { title: 'type', field: 'type', type: 'default', sort: true },
    {
      title: 'status',
      field: 'status',
      type: 'setAllocationStatus',
      sort: true,
    },
  ], []);

  const itemsColumns = useMemo(() => [
    { title: 'item code', field: 'code', type: 'default', sort: true },
    { title: 'description', field: 'description', type: 'default', sort: true },
    { title: 'type', field: 'type', type: 'default', sort: true },
    {
      title: 'status',
      field: 'status',
      type: 'setAllocationStatus',
      sort: true,
    },
  ], []);

  return (
    <div className='dispatch-modal__checklists-container'>
      <div>
        <div className='dispatch-modal__checklists-title-container'>
          <KitIcon />
          <div className='m-l-md font-bold'>
            Kits
          </div>
        </div>
        <div>
          <Table
            rows={kits}
            columns={kitsColumns}
            handleCheck={onKitSelected}
            checkedRows={selectedKits}
            handleCheckAll={onSelectAllKits}
            rowColor="#fafafa"
            rowBorderColor="#ffffff"
          />
        </div>
      </div>

      <div className='m-t-lg'>
        <div className='dispatch-modal__checklists-title-container'>
          <ItemIcon />
          <div className='m-l-md font-bold'>
            Items
          </div>
        </div>
        <div>
          <Table
            rows={items}
            columns={itemsColumns}
            handleCheck={onItemSelected}
            checkedRows={selectedItems}
            handleCheckAll={onSelectAllItems}
            rowColor="#fafafa"
            rowBorderColor="#ffffff"
          />
        </div>
      </div>
    </div>
  );
};

export default DispatchChecklistsContainer;
